import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import config from '@/config'

Vue.config.productionTip = false
Vue.use(ElementUI)
// 开发环境不走代理，直接跨域请求后端   生产环境走 /api/portal 路径
const visitApi = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api/portal' : process.env.VUE_APP_BASE_URL + '/api/portal',
  timeout: 10000    // （10 秒超时）
})

function recordVisit(page) {
  visitApi.post('/visit/record', { page }).catch(() => {
  })
}

router.afterEach((to) => {
  recordVisit(to.path)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
